import { render, staticRenderFns } from "./SharedDocumentList.vue?vue&type=template&id=b3811024&scoped=true&"
import script from "./SharedDocumentList.vue?vue&type=script&lang=js&"
export * from "./SharedDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./SharedDocumentList.vue?vue&type=style&index=0&id=b3811024&prod&lang=scss&scoped=true&"
import style1 from "./SharedDocumentList.vue?vue&type=style&index=1&id=b3811024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3811024",
  null
  
)

export default component.exports